import { Navigate, useLocation } from "react-router-dom";
import { getSessionToken } from "../utils/auth";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!getSessionToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
